// extracted by mini-css-extract-plugin
module.exports = {"card":"local-services_card__BdFtu"};